import { lazy, Suspense } from "react";
import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { Styles } from "../styles/styles";
import {useAuth } from "../hooks/auth"

//import loadable from '@loadable/component';

//const Home = loadable(() => import('../pages/Home'));
const Home = lazy(() => import('../pages/Home'));
const Aht = lazy(() => import('../pages/Home/aht'));
const Cse = lazy(() => import('../pages/Home/cse'));
const Secretary = lazy(() => import('../pages/Home/secretary'));
const Crowdfund = lazy(() => import('../pages/Home/crowdfund'));
const Account = lazy(() => import('../pages/Home/account'));
const Login = lazy(() => import('../pages/Home/login'));
const Register = lazy(() => import('../pages/Home/register'));
const Forgot = lazy(() => import('../pages/Home/forgot'));
const Reset = lazy(() => import('../pages/Home/reset'));
const Profile = lazy(() => import('../pages/Home/user/profile'));
const Tos = lazy(() => import('../pages/Home/tos'));
const Privacy = lazy(() => import('../pages/Home/privacy'));
const About = lazy(() => import('../pages/Home/about'));
const PressKits = lazy(() => import('../pages/Home/presskits'));
const VerifyEmail = lazy(() => import('../pages/Home/verifyEmail'));
const ActivateClient = lazy(() => import('../pages/Home/activateClient'));
const RegisterPatreon = lazy(() => import('../pages/Home/RegisterPatreon'));
const Faq = lazy(() => import('../pages/Home/faq'));
const Changelog = lazy(() => import('../pages/Home/changelog'));
const Blog = lazy(() => import('../pages/Home/blog'));
const Curation = lazy(() => import('../pages/Home/curation'));
const Commissioning = lazy(() => import('../pages/Home/commissioning'));
const Errorpage = lazy(() => import('../pages/Home/errorpage'));
const CloudLogin = lazy(() => import('../pages/Home/cloudlogin'));
const CloudProfile = lazy(() => import('../pages/Home/cloudprofile'));

//import Home from "../pages/Home";
// import Cse from "../pages/Home/cse";
// import Aht from "../pages/Home/aht";
// import Crowdfund from "../pages/Home/crowdfund";

// Renders child element if autharized. otherwise goes to login page
function PrivateOutlet() {
  const auth = useAuth();
  //return auth ? <Outlet /> : <Navigate to="/login" />;
  // BYPASS for dev!!
  return <Outlet />;
}

const Router = () => {
  return (
    <Suspense fallback={null}>
      <Styles />
      <Header />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/cse_game" element={<Cse />} />
        <Route path="/secretary" element={<Secretary />} />
        <Route path="/aht" element={<Aht />} />
        <Route path="/crowdfund" element={<Crowdfund />} />
        {/* <Route path="/account" element={<Account />} /> */}
        <Route path="/login" element={<Login />} />
        <Route path="/verifyEmail" element={<VerifyEmail />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot" element={<Forgot />} />
        <Route path="/reset" element={<Reset />} />
        <Route path="/tos" element={<Tos />} />
        <Route path="/privacy" element={<Privacy />} />
  <Route path="/about" element={<About />} />
  <Route path="/presskits" element={<PressKits />} />
        <Route path="/activateClient" element={<ActivateClient />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/changelog" element={<Changelog />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:postId" element={<Blog />} />
        <Route path="/curation" element={<Curation />} />
        <Route path="/commissioning" element={<Commissioning />} />        
        <Route path="/error" element={<Errorpage />} />    
        <Route path="/cloudlogin" element={<CloudLogin />} />
        <Route path="/cloudprofile" element={<CloudProfile />} />

        {/* Private routes */}
        <Route path="/account" element={<PrivateOutlet />}>
          <Route path="/account" element={<Account />} />
        </Route>
        <Route path="/account/profile" element={<PrivateOutlet />}>
          <Route path="/account/profile" element={<Profile />} />
        </Route>
        <Route path="/register" element={<PrivateOutlet />}>
          <Route path="/register" element={<RegisterPatreon />} />
        </Route>
        

      </Routes>
      <Footer />
    </Suspense>
  );
};

export default Router;
